<!-- 电商场景中的横滑消息 -->
<template>
    <div class="goods-side-slip-box" :class="isMobile ? 'h5' : 'pc'">
     <div class="side-slip">
      <div class="side-slip__item" @click="jumpLinkUrl(item)"
      v-for="(item, index) in message" :key="index">
          <div class="side-slip__img">
              <img :src="item.image">
          </div>
          <div class="side-slip__info">
              <div class="side-slip__title">
                {{ item.title ? item.title : ''}}
              </div>
              <div class="side-slip__sale">
                  <div class="side-slip__price">
                    {{`${item.currencyUnit ? item.currencyUnit : '¥'} ${ item.price }`}}
                  </div>
                  <div class="side-slip__desc">
                    {{ item.sales }}件已售
                  </div>
              </div>
          </div>
      </div>
     </div>
    </div>
</template>

<script>

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      message: '',
    };
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },
  mounted() {
    this.message = typeof this.data.content.content === 'string' ? JSON.parse(this.data.content.content) : this.data.content.content;
  },
  methods: {
    jumpLinkUrl(item) {
      if (item.jumpURL) {
        window.open(item.jumpURL, '_blank');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.goods-side-slip-box {
  position: relative;
  .side-slip {
        box-sizing: border-box;
        display: flex;
        padding: 20px 1px;
        width: 100%;
        overflow-x: auto;
        .side-slip__item {
            flex-shrink: 0;
            box-sizing: border-box;
            width: 156px;
            box-shadow: 0px 1px 10px rgba(225, 230, 240, 0.5);
            border-radius: 6px;
            background-color: #fff;
            &:not(:last-child) {
                margin-right: 12px;
            }
            .side-slip__img {
                img {
                    width: 156px;
                    height: 156px;
                    border-radius: 6px 6px 0 0;
                }
            }
            .side-slip__info {
                padding: 8px 12px 12px 12px;
                .side-slip__title {
                    height: 40px;
                    color: #000000;
                    font-size: 14px;
                    line-height: 20px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: inherit;
                    word-break: break-all;
                }
                .side-slip__sale {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 8px;
                    font-size: 12px;
                    .side-slip__price {
                        color: #FF8147;
                        font-weight: 500;
                    }
                    .side-slip__desc {
                        color: #A1ABC2;
                        flex-shrink: 0;
                        max-width: 55px;
                    }
                }
            }
        }
  }
}
.pc.goods-side-slip-box {
    box-sizing: border-box;
    overflow: hidden;
    font-style: normal;
    max-width: 100%;
    width: 100%;
}
.h5.goods-side-slip-box {
    box-sizing: border-box;
    overflow: hidden;
    font-style: normal;
    width: 100vw;
}


</style>
